module.exports = __webpack_public_path__ + "img/ics_o_arrow_up.3384da00.svg";